import React, { useState, useEffect } from 'react';
import Header from '../../components/Header';
import { useHistory } from "react-router-dom";
import './index.css';
import api from '../../services/api_irrigacao';
// import apiadi from '../../services/api_adiantamento';
import { parse } from 'date-fns';
import { format } from 'date-fns-tz';
import { mask, unMask } from 'remask';
// import apidelphi from '../../services/api_delphi';


export default function Importacao() {

    const [irrigacoes, setIrrigacoes] = useState([]);
    const [pages, setPages] = useState({});
    const [pageClicked, setPageClicked] = useState(1);
    const [data, setData] = useState('');
    const [os, setOs] = useState('');
    const [frota, setFrota] = useState('');
    const [imp, setImp] = useState('');
    const [fazenda, setFazenda] = useState('');
    const [talhao, setTalhao] = useState('');
    const [filtrando, setFiltrando] = useState(false);
    const [filter, setFilter] = useState(false);
    const [tipoAplicacao, setTipoAplicacao] = useState({
        items: [
            { id: 0, text: "TODOS" },
            { id: 1, text: "CONVENCIONAL" },
            { id: 2, text: "HIDRO-ROLL" },
            { id: 3, text: "LOCALIZADA" },
        ],
        selectItem: 0
    });
    const [tipoIrrigacao, setTipoIrrigacao] = useState({
        items: [
            { id: 0, text: "TODOS" },
            { id: 1, text: "AGUA" },
            { id: 2, text: "VINHAÇA" },
        ],
        selectItem: 0
    });
    const [atualizar, setAtualizar] = useState(false);
    const [safra, setSafra] = useState('');
    const [etapa, setEtapa] = useState('');
    const [operacao, setOperacao] = useState('');
    const [modalPartesOpen, setModalPartesOpen] = useState(false);
    const [importador, setImportador] = useState({});
    const [time, setTime] = useState(0);

    let history = useHistory();

    function handleSearch() {

        setFiltrando(true);
        var filtros = '';

        filtros = filtros + '?page=' + pageClicked;

        if (tipoAplicacao.selectItem !== 0) {
            filtros = filtros + '&ope_tipo_aplicacao_id=' + tipoAplicacao.selectItem;
        }

        if (tipoIrrigacao.selectItem !== 0) {
            filtros = filtros + '&ope_tipo_irrigacao_id=' + tipoIrrigacao.selectItem;
        }

        if (data !== null && data !== '') {
            filtros = filtros + '&dt_lcto=' +
                format(parse(data, 'dd/MM/yyyy', new Date()), 'yyyy-MM-dd', { timeZone: 'America/Sao_Paulo' });
        }


        if (os !== null && os !== '') {
            filtros = filtros + '&num_os=' + data;
        }

        if (frota !== null && frota !== '') {
            filtros = filtros + '&cod_frota=' + frota;
        }

        if (imp !== null && imp !== '') {
            filtros = filtros + '&implemento=' + imp;
        }

        if (fazenda !== null && fazenda !== '') {
            filtros = filtros + '&fazenda=' + fazenda;
        }

        if (talhao !== null && talhao !== '') {
            filtros = filtros + '&cod_talhao=' + talhao;
        }

        if (etapa !== null && etapa !== '') {
            filtros = filtros + '&etapa=' + etapa;
        }

        if (operacao !== null && operacao !== '') {
            filtros = filtros + '&operacao=' + operacao;
        }
        api.get(`/capa${filtros}`).then(function (response) {
            if (response.data) {
                setIrrigacoes(response.data.capa);
                const newpage = {
                    nextpage: response.data.nextpage,
                    currentpage: response.data.currentpage,
                    lastpage: response.data.lastpage,
                    prevpage: response.data.prevpage,
                }
                setPages(newpage);
                setFiltrando(false);
            }
        }).catch(function (error) {
            // handle error
            alert(error);
            console.log(error);
        }).then(function () {
            // always executed
        });

    }

    useEffect(() => {
        handleSearch();
    }, []);

    function handlePageClick(page) {
        if (page <= pages.lastpage && page > 0) {
            setPageClicked(page);
            setFilter(true);
        }

    }

    useEffect(() => {
        if (filter === true) {
            handleSearch();
            setFilter(false);
        }
    }, [filter]);

    function renderpages() {
        return (
            <div>
                {(() => {
                    const options = [];
                    options.push(<i className="paginas" onClick={() => handlePageClick(1)}>Primeira</i>);
                    options.push(<i className="paginas" onClick={() => handlePageClick(pages.prevpage)}>Anterior</i>);
                    if (pages.lastpage > 20) {
                        if (pages.currentpage < 10) {
                            for (let i = 1; i <= 20; i++) {
                                if (i === pages.currentpage) {
                                    options.push(<i value={i} className="paginas selected" onClick={() => handlePageClick(i)}>{i}</i>);
                                } else {
                                    options.push(<i value={i} className="paginas" onClick={() => handlePageClick(i)}>{i}</i>);
                                }

                            }
                        } else {
                            if (pages.currentpage + 10 < pages.lastpage) {
                                for (let i = pages.currentpage - 10; i <= pages.currentpage + 10; i++) {
                                    if (i === pages.currentpage) {
                                        options.push(<i value={i} className="paginas selected" onClick={() => handlePageClick(i)}>{i}</i>);
                                    } else {
                                        options.push(<i value={i} className="paginas" onClick={() => handlePageClick(i)}>{i}</i>);
                                    }

                                }
                            } else {
                                for (let i = pages.lastpage - 20; i <= pages.lastpage; i++) {
                                    if (i === pages.currentpage) {
                                        options.push(<i value={i} className="paginas selected" onClick={() => handlePageClick(i)}>{i}</i>);
                                    } else {
                                        options.push(<i value={i} className="paginas" onClick={() => handlePageClick(i)}>{i}</i>);
                                    }

                                }
                            }

                        }

                    } else {
                        for (let i = 1; i <= pages.lastpage; i++) {
                            if (i === pages.currentpage) {
                                options.push(<i value={i} className="paginas selected" onClick={() => handlePageClick(i)}>{i}</i>);
                            } else {
                                options.push(<i value={i} className="paginas" onClick={() => handlePageClick(i)}>{i}</i>);
                            }

                        }
                    }

                    options.push(<i className="paginas" onClick={() => handlePageClick(pages.nextpage)}>Próxima</i>);
                    options.push(<i className="paginas" onClick={() => handlePageClick(pages.lastpage)}>Ultima</i>);
                    return options;
                })()}
            </div>
        )

    }

    function clickTbIrrigacao(e) {
        e.preventDefault();
        // history.push('/novairrigacao/' + e.target.id);
        const win = window.open("/novairrigacao/" + e.target.id, "_blank");
        win.focus();
    }

    function rowOperacoes(irrigacao) {
        return (
            <tr key={irrigacao.id} className="troperacao" onClick={clickTbIrrigacao}>
                <td id={irrigacao.id}>{format(parse(irrigacao.dt_irrigacao, 'yyyy-MM-dd', new Date()), 'dd/MM/yyyy', { timeZone: 'America/Sao_Paulo' })}</td>
                <td id={irrigacao.id}>{irrigacao.tipo_aplicacao ? irrigacao.tipo_aplicacao : ''}</td>
                <td id={irrigacao.id}>{irrigacao.tipo_irrigacao ? irrigacao.tipo_irrigacao : ''}</td>
                <td id={irrigacao.id}>{irrigacao.num_os}</td>
                <td id={irrigacao.id}>{irrigacao.frota ? irrigacao.frota : ''}</td>
                <td id={irrigacao.id}>{irrigacao.desc_frota ? irrigacao.desc_frota : ''}</td>
                <td id={irrigacao.id}>{irrigacao.implemento ? irrigacao.implemento : ''}</td>
            </tr>
        )
    }

    function opennew(e) {
        e.preventDefault();
        history.push('/novairrigacao');
    }

    function openReports(e) {
        e.preventDefault();
        history.push('/relatorios');
    }

    function handleSelecTipoAplicacao(value) {
        const tipos = Object.assign([], tipoAplicacao);
        tipos.selectItem = value;
        setTipoAplicacao(tipos);
    }

    function handleSelecTipoIrrigacao(value) {
        const tipo = Object.assign([], tipoIrrigacao);
        tipo.selectItem = value;
        setTipoIrrigacao(tipo);
    }

    function handleMaskData(value) {
        const originalValue = unMask(value);
        const maskedValue = mask(originalValue, [
            "9", "99", "99/9", "99/99", "99/99/9", "99/99/99", "99/99/999", "99/99/9999",
        ]);
        setData(maskedValue);
    }

    function handleClickSearch() {

        if (filtrando === true) {
            return;
        }

        setFilter(true);
    }

    function renderSpin() {
        if (filtrando) {
            return (
                <>
                    <div className="column-buttom">
                        <input type="submit" value="FILTRAR" className="btn btn-info normal btn-sm" onClick={() => handleClickSearch()} />
                    </div>
                    <div className="column-spin">
                        <div className='spinner'></div>
                    </div>
                </>
            )
        } else {
            return (
                <>
                    <div className="column-buttom">
                        <input type="submit" value="FILTRAR" className="btn btn-warning btn-sm" onClick={() => handleClickSearch()} />
                    </div>
                </>
            )
        }
    }

    // function atualizaPartes() {
    //     if (safra !== '' && safra.length === 4) {
    //         setAtualizar(true);
    //         if (!atualizar) {
    //             apidelphi.get(`/import?importador=partes&safra=${safra}`)
    //                 .then(function (response) {
    //                     if (response.data) {
    //                         setAtualizar(false);
    //                         alert(`PARTES ATUALIZADAS PARA A SAFRA ${safra}`);
    //                     }
    //                 }).catch(function (error) {
    //                     // handle error
    //                     alert(error);
    //                     console.log(error);
    //                 }).then(function () {
    //                     // always executed
    //                 });
    //         }
    //     } else {
    //         alert('VERIFIQUE OS DADOS INFORMADOS E TENTE NOVAMENTE!')
    //     }
    // }

    // function renderspin() {
    //     if (atualizar) {
    //         return (
    //             <div className='spinner'></div>
    //         )
    //     } else {
    //         return (
    //             <>
    //                 &nbsp;
    //                 &nbsp;
    //             </>
    //         )
    //     }
    // }

    function fecharModalParte() {
        setImportador({});
        setModalPartesOpen(false);
    }

    // useEffect(() => {
    //     if (modalPartesOpen) {
    //         apiadi.get(`/importadores/importador?descricao=PARTES`).then(function (response) {
    //             if (response.data) {
    //                 setImportador(response.data)
    //                 setTimeout(function () {
    //                     setTime(time + 1);
    //                 }, 3000);
    //             }
    //         }).catch(function (error) {
    //             // handle error
    //             console.log(error);
    //         }).then(function () {
    //             // always executed
    //         });
    //     }
    // }, [time, modalPartesOpen]);

    useEffect(() => {
        if(modalPartesOpen) {
            api.get(`/talhao/attpartes`).then(response => {
                if(response.error) {
                    console.log(response.error);
                } else if(response.data) {
                    setImportador(response.data);
                }
            }).catch(error => {
                // handle error
                console.log(error);
            });
        }
    }, [modalPartesOpen]);

    // function renderstatus(importacao) {

    //     if (!importacao.id) {
    //         return;
    //     }
    //     if (importacao.importadores_status[0].status === 0) {
    //         return (
    //             <div className="Footer">
    //                 <div className="context">
    //                     Status: Aguardando
    //                 </div>
    //                 <div className="body-spinner">
    //                     {renderspin()}
    //                 </div>
    //             </div>
    //         )
    //     } else if (importacao.importadores_status[0].status === 6) {
    //         return (
    //             <div className="Footer">
    //                 <div className="context">
    //                     Status: Excluindo
    //                 </div>
    //                 <div className="body-spinner">
    //                     {renderspin()}
    //                 </div>
    //             </div>
    //         )
    //     } else if (importacao.importadores_status[0].status === 1) {
    //         return (
    //             <div className="Footer">
    //                 <div className="context">
    //                     Status: Erro
    //                 </div>
    //             </div>
    //         )
    //     } else if (importacao.importadores_status[0].status === 2) {
    //         return (
    //             <div className="Footer">
    //                 <div className="context">
    //                     Status: Baixando
    //                 </div>
    //                 <div className="context">
    //                     Servidor: {importacao.importadores_status[0].servidor}
    //                 </div>
    //                 <div className="body-spinner">
    //                     {renderspin()}
    //                 </div>
    //             </div>
    //         )
    //     } else if (importacao.importadores_status[0].status === 3) {
    //         return (
    //             <div className="Footer">
    //                 <div className="context">
    //                     Status: Inserindo
    //                 </div>
    //                 <div className="context">
    //                     Servidor: {importacao.importadores_status[0].servidor}
    //                 </div>
    //                 <div className="body-spinner">
    //                     {renderspin()}
    //                 </div>
    //             </div>
    //         )
    //     } else if (importacao.importadores_status[0].status === 4) {
    //         return (
    //             <div className="Footer">
    //                 <div className="context">
    //                     Status: Sincronizando
    //                 </div>
    //                 <div className="body-spinner">
    //                     {renderspin()}
    //                 </div>
    //             </div>
    //         )
    //     } else if (importacao.importadores_status[0].status === 5) {
    //         return (
    //             <div className="Footer">
    //                 <div className="context">
    //                     Status: Concluido
    //                 </div>
    //             </div>
    //         )
    //     }
    // }

    // function renderButtonAtualizar() {
    //     if (importador && importador.id) {
    //         if (importador.importadores_status[0].status === 5 || importador.importadores_status[0].status === 1) {
    //             return (
    //                 <button className="btn btn-spin btn-success espaco m-top" onClick={() => atualizaPartes()}>
    //                     ATUALIZAR &nbsp;
    //                     {renderspin()}
    //                 </button>
    //             )
    //         } else {
    //             return ('')
    //         }

    //     } else {
    //         return ('')
    //     }

    // }

    function renderAttPartes() {
        if(importador.ultima_atualizacao) {
            return <div><b>Última atualização concluída em: </b><u>{importador.ultima_atualizacao}</u></div>
        } else {
            return <div style={{display: 'grid', justifyContent: 'center', paddingTop: '20px'}}><div className='spinner'></div></div>
        }
    }

    function renderModalPartes() {
        return (
            <div className={(modalPartesOpen ? "modal-partes container-lg" : "modal-fechado")}>
                <span className="fechar-modal-previsoes" onClick={() => fecharModalParte()}>x</span>
                <div>
                    <h4>ATUALIZAÇÃO DE PARTES</h4>
                </div>
                <div className="itens-modal-insumos">
                    <div style={{paddingTop: '10px', fontSize: '20px'}}>
                        <div><b>A atualização de Partes agora é feita de forma automatica.</b></div>
                        {renderAttPartes()}
                    </div>
                </div>
                {/* <div className="itens-modal-insumos">
                    <hr></hr>
                    <div className="form modal-insumos">
                        <div className="">
                            <label>SAFRA:</label>
                            <input
                                type="text"
                                id="operacao"
                                // ref={novoOperacaoInsumoRef}
                                // onKeyDown={(e) => handleBuscaNovaOperacao(e)}
                                className="form-control edit"
                                value={safra}
                                onChange={(e) => setSafra(e.target.value)}
                            />
                        </div>
                        <div className="">
                            {renderButtonAtualizar()}
                        </div>
                        <div className="card-import">
                            <div className="containder-title Content">
                                {importador.descricao}
                            </div>
                            {renderstatus(importador)}
                            <div className="horas">
                                Atualizado em: {(importador && importador.importadores_status ? moment(importador.importadores_status[0].updatedAt).utc().format('DD/MM/YYYY HH:mm:ss') : '')}
                            </div>
                        </div>
                    </div>
                </div> */}
            </div>
        )
    }

    function openoutorgas() {
        history.push('/outorgas');
    }

    return (
        <div className="container-lg">
            {renderModalPartes()}
            <Header title="IRRIGAÇÃO" />
            <div className="importacoes">
                <div className="flex-container-lg">
                    <div className="col col-md-12">
                        <input type="buttom" value="NOVO" className="btn btn-success col col-md-1 espaco" onClick={opennew} />
                        <input type="buttom" value="RELATÓRIOS" className="btn btn-info col col-md-1 espaco" onClick={openReports} />
                        <input type="button" value="PARTES" className="btn btn-warning col col-md-1 espaco" onClick={() => setModalPartesOpen(true)} />
                        <input type="buttom" value="OUTORGAS" className="btn btn-success col col-md-1 espaco" onClick={() => openoutorgas()} />
                    </div>
                </div>

                {/* <div id="abrirModal" className="modald border">
                    <a href="#fechar" className="fechar">x</a>
                    <b>ATUALIZAR PARTES</b>
                    <hr></hr>
                    <div className="form modal-insumos">
                        <div className="column-insumos">
                            <div className="column-num">
                                <label>SAFRA:</label>
                                <input
                                    type="text"
                                    id="operacao"
                                    // ref={novoOperacaoInsumoRef}
                                    // onKeyDown={(e) => handleBuscaNovaOperacao(e)}
                                    className="form-control edit"
                                    value={safra}
                                    onChange={(e) => setSafra(e.target.value)}
                                />
                            </div>
                            <div className="column-descricao">
                                <button className="btn btn-spin btn-success espaco m-top" onClick={() => atualizaPartes()}>
                                    ATUALIZAR &nbsp;
                                    {renderspin()}
                                </button>
                            </div>

                        </div>

                    </div>
                </div> */}
                <br></br>
                <div className="content border filtros">
                    <div>
                        <b>FILTROS:</b>
                    </div>
                    <div className="form">
                        <div className="column-tipo">
                            <label>Tipo Aplicação:</label>
                            <select
                                className="col-md-12 combobox  edit form-control"
                                value={tipoAplicacao.selectItem}
                                onChange={(e) => handleSelecTipoAplicacao(e.target.value)}
                            // ref={tipoAplicRef}
                            // onKeyDown={(e) => handledown(e, tipoIrrigRef)}
                            >
                                {tipoAplicacao.items.map((item, index) => (
                                    <option key={index} value={item.id}>{item.text}</option>
                                ))}
                            </select>
                        </div>
                        <div className="column-agua">
                            <label>Tipo Irrig.:</label>
                            <select
                                className="col-md-11 combobox edit form-control"
                                value={tipoIrrigacao.selectItem}
                                onChange={(e) => handleSelecTipoIrrigacao(e.target.value)}
                            // ref={tipoIrrigRef}
                            // onKeyDown={(e) => handledown(e, dataRef)}
                            >
                                {tipoIrrigacao.items.map((item, index) => (
                                    <option key={index} value={item.id}>{item.text}</option>
                                ))}
                            </select>
                        </div>
                        <div className="column-data">
                            <label>Data:</label>
                            <input
                                type="text"
                                id="data"
                                // ref={dataRef}
                                value={data}
                                className="form-control edit"
                                // onKeyDown={(e) => handledown(e, osRef)}
                                onChange={(e) => handleMaskData(e.target.value)}
                            />
                        </div>

                        <div className="column-num">
                            <label>O.S.:</label>
                            <input
                                id="os"
                                value={os}
                                // onKeyDown={(e) => handledown(e, frotaRef)}
                                // ref={osRef}
                                className="form-control edit" type="text"
                                onChange={(e) => setOs(e.target.value)}
                            />
                        </div>
                        <div className="column-num">
                            <label>Frota:</label>
                            <input
                                id="frota"
                                value={frota}
                                // ref={frotaRef}
                                // onKeyDown={(e) => handledown(e, impRef)}
                                className="form-control edit"
                                type="text"
                                onChange={(e) => setFrota(e.target.value)}
                            />
                        </div>
                        <div className="column-num">
                            <label>Imp.:</label>
                            <input
                                id="implemento"
                                onChange={(e) => setImp(e.target.value)}
                                // ref={impRef}
                                // onKeyDown={(e) => handleSalvarCapa(e)}
                                className="form-control edit"
                                type="text"
                                value={imp}
                            />
                        </div>
                        <div className="column-num">
                            <label>Faz.:</label>
                            <input
                                id="fazenda"
                                onChange={(e) => setFazenda(e.target.value)}
                                // ref={impRef}
                                // onKeyDown={(e) => handleSalvarCapa(e)}
                                className="form-control edit"
                                type="text"
                                value={fazenda}
                            />
                        </div>
                        <div className="column-num">
                            <label>Talh.:</label>
                            <input
                                id="talhao"
                                onChange={(e) => setTalhao(e.target.value)}
                                // ref={impRef}
                                // onKeyDown={(e) => handleSalvarCapa(e)}
                                className="form-control edit"
                                type="text"
                                value={talhao}
                            />
                        </div>
                        <div className="column-num">
                            <label>Etapa:</label>
                            <input
                                id="etapa"
                                onChange={(e) => setEtapa(e.target.value)}
                                // ref={impRef}
                                // onKeyDown={(e) => handleSalvarCapa(e)}
                                className="form-control edit"
                                type="text"
                                value={etapa}
                            />
                        </div>
                        <div className="column-num">
                            <label>Operacao:</label>
                            <input
                                id="operacao"
                                onChange={(e) => setOperacao(e.target.value)}
                                // ref={impRef}
                                // onKeyDown={(e) => handleSalvarCapa(e)}
                                className="form-control edit"
                                type="text"
                                value={operacao}
                            />
                        </div>
                        {renderSpin()}
                    </div>
                </div>
                <div className="content border lctos-capa">
                    <table className="table table-borderless table-sm operacoes">
                        <thead>
                            <tr>
                                <th scope="col">Data</th>
                                <th scope="col">Tipo Aplicação</th>
                                <th scope="col">Tipo Irrigação</th>
                                <th scope="col">O.S.</th>
                                <th scope="col">Cod. Frota</th>
                                <th scope="col">Descrição</th>
                                <th scope="col">Impl.</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                irrigacoes.map(irrigacao => {
                                    return (
                                        rowOperacoes(irrigacao)
                                    )
                                })
                            }
                        </tbody>
                    </table>

                </div>
                {renderpages()}
            </div>
        </div >
    )
}